import React, { forwardRef } from "react";
import Icon from "../atoms/Icon";
import LinkButton from "../atoms/LinkButton";

export default forwardRef(({ onClick, className, iconClassName, iconName, iconToTheRight, url, text, rel = undefined, disabled = false , type = "", form = ""}, ref) =>
    <LinkButton
        onClick={ onClick }
        className={ "m-btn-extended" + (className ? " " + className : "") }
        url={ url }
        ref={ ref }
        disabled={ disabled }
        type={ type }
        form={ form }
        rel={ rel }
    >
        { !iconToTheRight &&
        <Icon className={ "m-btn-extended__icon a-icon" + (iconClassName ? " " + iconClassName : "") }
              iconName={ iconName }/>
        }
        <span className="m-btn-extended__text">{ text }</span>
        { iconToTheRight &&
        <Icon className={ "m-btn-extended__icon a-icon" + (iconClassName ? " " + iconClassName : "") }
              iconName={ iconName }/>
        }
    </LinkButton>
);
